<script lang="ts" setup>
import supportImg from '@/assets/support-1.webp'
import support2Img from '@/assets/support-2.webp'
import support3Img from '@/assets/support-3.webp'
import support4Img from '@/assets/support-4.webp'
import { getUrl } from '@/lib/helpers'

const amounts: {
  value: number
  label: string
}[] = [
  { value: 50, label: '50zł' },
  { value: 100, label: '100zł' },
  { value: 150, label: '150zł' },
  { value: 200, label: '200zł' },
  { value: 500, label: '500zł' },
  { value: 750, label: '750zł' },
  { value: 1000, label: '1000zł' },
  { value: 0, label: 'Inna' },
]

const imageSize = useImageSize()

useSeoMeta({
  title: () => 'Wesprzyj nas',
  ogTitle: () => 'Wesprzyj nas',
  ogUrl: () => getUrl('/wesprzyj-nas'),
})
</script>

<template>
  <v-img
    eager
    :src="supportImg"
    class="align-center"
    cover
    height="calc(100svh - var(--v-layout-top)"
    alt="Wesprzyj nas"
  >
    <v-container class="d-flex flex-column ga-3 text-white text-center" max-width="640">
      <div class="text-h5 text-lg-h4 font-weight-bold">
        Hojność to forma uwielbienia, która zmienia rzeczywistość
      </div>
      <div class="text-subtitle-2 text-lg-h6 font-weight-regular">
        Wspierając CSM modlitewnie i finansowo pomagasz nam realizować
        Boże cele i marzenia, które nosimy w sercu.
      </div>
    </v-container>
  </v-img>
  <div class="d-flex flex-column ga-6 ga-lg-12 my-6 my-lg-12">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
          class="d-flex justify-lg-center"
        >
          <div class="d-flex flex-column ga-5 pa-lg-12">
            <div class="text-h5 text-lg-h4 font-weight-medium">
              Twoje wsparcie przeznaczymy na:
            </div>
            <ul class="text-subtitle-1 font-weight-regular pa-5">
              <li>rozwijanie działalności statutowej Misji CSM</li>
              <li>organizowanie kolejnych wieczorów modlitwy i uwielbienia</li>
              <li>produkcję wydarzeń i streamów w internecie</li>
              <li>pisanie i publikowanie nowych pieśni uwielbienia</li>
              <li>utrzymanie stałych pracowników Misji</li>
              <li>pokrycie kosztów osób zaangażowanych w projekty misyjne</li>
              <li>inwestycje w potrzebny sprzęt audio i video</li>
              <li>rozwój muzycznej służby uwielbienia w Polsce!</li>
            </ul>
          </div>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
        >
          <v-img
            eager
            :aspect-ratio="imageSize"
            class="mt-6 mt-lg-0"
            width="100%"
            height="100%"
            :src="support2Img"
            color="gray-300"
            rounded="xl"
            cover
            alt="Cele wsparcia"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <div class="d-flex flex-column ga-10 pt-lg-6">
        <div class="text-h5 text-lg-h4 text-lg-center">
          Wybierz kwotę wsparcia
        </div>
        <div class="d-flex flex-wrap ga-8 justify-center">
          <v-btn
            v-for="amount in amounts"
            :key="amount.label"
            variant="outlined"
            rounded="xl"
            :width="$vuetify.display.smAndDown ? 'calc(35% - 32px)' : 'calc(25% - 32px)'"
            :block="$vuetify.display.xs"
            class="border-opacity-100 text-subtitle-1"
            border="sm"
            height="96"
            target="_blank"
            :href="`https://ssl.dotpay.pl/t2/?id=438762&currency=PLN&amount=${amount.value}&description=Darowizna+na+misj%C4%99+%28Misja+Chrze%C5%9Bcija%C5%84ska+S%C5%82u%C5%BCba+Muzyczna%29`"
            :text="amount.label"
          />
        </div>
      </div>
    </v-container>
    <v-container>
      <div class="d-flex flex-column ga-4 text-lg-center py-lg-12">
        <div class="text-h5">
          Swoje wsparcie możesz przesłać bezpośrednio na konto mBank
        </div>
        <div class="text-h3 font-weight-bold">
          44 1140 2017 0000 4502 1286 2590
        </div>
      </div>
    </v-container>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
          class="d-flex justify-lg-center"
        >
          <div class="d-flex flex-column ga-5 pa-lg-12">
            <div class="text-h5 text-lg-h4 font-weight-medium">
              Patronite
            </div>
            <p class="text-subtitle-2 font-weight-regular">
              Dzięki tej platformie możesz wspierać nas regularnie, co miesiąc
              wpłacając wybraną przez Ciebie kwotę na projekt CSM/worship.
            </p>
            <v-btn
              href="https://patronite.pl/CSM"
              target="_blank"
              rounded="lg"
              color="#EF3E27"
              text="Dowiedz się więcej"
              max-width="200"
            />
          </div>
        </v-col>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
        >
          <v-img
            eager
            :aspect-ratio="imageSize"
            class="mt-6 mt-lg-0"
            width="100%"
            height="100%"
            :src="support3Img"
            color="gray-300"
            rounded="xl"
            cover
            alt="Patronite"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
          order="2"
          order-lg="1"
        >
          <v-img
            eager
            :aspect-ratio="imageSize"
            class="mt-6 mt-lg-0"
            width="100%"
            height="100%"
            :src="support4Img"
            color="gray-300"
            rounded="xl"
            cover
            alt="International giving"
          />
        </v-col>
        <v-col
          cols="12"
          lg="6"
          align-self="center"
          class="d-flex justify-lg-center"
          order="1"
          order-lg="2"
        >
          <div class="d-flex flex-column ga-5 pa-lg-12">
            <div class="text-h5 text-lg-h4 font-weight-medium">
              International giving
            </div>
            <p class="text-subtitle-2 font-weight-regular">
              If you would like to support us from abroad, you can do it via PayPal.
            </p>

            <v-btn
              href="https://www.paypal.com/donate/?hosted_button_id=RPADYRYNZQ7SL"
              target="_blank"
              rounded="lg"
              class="text-white"
              color="#232323"
              text="Give via Paypal"
              max-width="200"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <div class="d-flex flex-column ga-2 text-h6 text-lg-center py-lg-6">
        <div class="font-weight-bold">
          Jeśli chcesz zostać naszym stałym partnerem w modlitwie – napisz do nas:
        </div>
        <div class="font-italic">
          misja.csm@gmail.com
        </div>
        <div class="font-weight-bold">
          Dziękujemy za każdą modlitwę i finansowe wsparcie!
        </div>
      </div>
    </v-container>
  </div>
</template>
